<template>
  <div>
    <BreadCrumb class="bread" :breads="['广告管理','广告投放',operateName]"></BreadCrumb>
    <div class="header">
      <span class="nameFt">{{ operateName}}</span>
      <router-link :to="{path: '/index/advertisingdelivery',query:$route.params}">
        <el-button class="addCustom" size="small" icon="el-icon-arrow-left">返回列表</el-button>
      </router-link>
    </div>
    <el-form ref="form" size="small" :rules="rules" label-width="120px" :model="formData">
      <div class="form-container">
        <div class="form-container__left">
          <el-form-item label="投放任务名称" prop="name">
            <el-input v-model="formData.name" :readonly="isLook"></el-input>
          </el-form-item>
          <el-form-item label="投放格式选择" prop="serving_type">
            <el-select
              v-model="formData.serving_type"
              :disabled="isLook"
              @change="changeServingType"
            >
              <el-option label="视频" value="VIDEO"></el-option>
              <el-option label="图片" value="IMAGE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货柜选择" prop="terminal_ids">
            <el-tag
              style="margin:0 8px 8px 0;"
              v-for="(cabinet,index) in selectCabinetList"
              :key="cabinet.id"
              :closable="!isLook"
              type="primary"
              effect="plain"
              @close="removeCabinet(index)"
            >{{cabinet.data}}</el-tag>
            <div>
              <el-button type="primary" @click="addNewCabinet" v-show="!isLook">新增货柜</el-button>
            </div>
          </el-form-item>
          <el-form-item label="投放说明" prop="desc">
            <el-input
              type="textarea"
              autosize
              v-model="formData.desc"
              :readonly="isLook"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-container__right">
          <el-form-item label="投放时段" prop="time_start">
            <el-time-select
              v-model="formData.time_start"
              :readonly="isLook"
              style="width:150px;"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '24:00',
                maxTime: formData.time_end,
              }"
              placeholder="选择时间"
            ></el-time-select>~
            <el-time-select
              v-model="formData.time_end"
              :readonly="isLook"
              style="width:150px;"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '24:00',
                minTime: formData.time_start,
              }"
              placeholder="选择时间"
            ></el-time-select>
          </el-form-item>
          <el-form-item
            label="投放状态"
            v-show="this.$route.query.id"
          >{{examineStatus[formData.status]}}</el-form-item>
        </div>
      </div>
      <div style="padding:15px">
        <el-form-item label="广告列表">
          <el-button @click="addAdv" v-show="!isLook">新增</el-button>
          <el-table :data="formData.adv_details">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="广告名称" prop="title" align="center"></el-table-column>
            <el-table-column label="播放序号" align="center" width="100px">
              <div slot-scope="scope">
                <el-input type="text" v-model="scope.row.index" :readonly="isLook"></el-input>
              </div>
            </el-table-column>
            <el-table-column label="投放日期" align="center">
              <div slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.date"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  placeholder="选择日期"
                  class="inline-date-picker"
                  :picker-options="pickerOptions"
                  :readonly="isLook"
                ></el-date-picker>
              </div>
            </el-table-column>
            <el-table-column label="重复次数" align="center">
              <div slot-scope="scope">
                <el-input-number v-model="scope.row.replay" :step="1" :min="1" :disabled="isLook"></el-input-number>
              </div>
            </el-table-column>
            <el-table-column
              label="播放时长(秒)"
              align="center"
              v-if="formData.serving_type === 'IMAGE'"
            >
              <div slot-scope="scope">
                <el-input v-model="scope.row.play_time" :readonly="isLook"></el-input>
              </div>
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="!isLook">
              <div slot-scope="scope">
                <el-button size="small" @click="removeAdv(scope.$index)" type="danger">删除</el-button>
              </div>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
    </el-form>
    <div class="submit-container" v-if="!isLook">
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
    <simple-find-dialog
      :show="dialogVisible"
      @close="closeSimpleDialog"
      :dialogData="dialogData"
      :width="'500px'"
      :max="10"
    ></simple-find-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import simpleFindDialog from "@/components/SimpleFindDialog";
import apis from "@/config/apis";
import { dateFormat } from "@/plugins/util";
import { validate_decimal } from "@/plugins/common";
export default {
  components: {
    BreadCrumb,
    simpleFindDialog
  },
  data() {
    return {
      formData: {
        adv_details: [],
        serving_type: "VIDEO"
      },
      advTable: [],
      options: [],
      operateType: this.$route.query.operateType,
      dialogVisible: false,
      selectCabinetList: [],
      dialogData: {},
      nowDialog: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      examineStatus: {
        TO_BE_PUT: "待投放",
        PUTIN: "投放中",
        PUT: "投放结束"
      },
      rules: {
        name: {
          required: true,
          message: "请输入投放任务名称"
        },
        desc: {
          required: true,
          message: "请输入投放说明"
        },
        serving_type: {
          required: true,
          message: "请选择投放类型"
        },
        terminal_ids: {
          required: true,
          message: "请选择货柜"
        },
        note: {
          required: true,
          message: "请输入活动说明"
        },
        time_start: {
          required: true,
          message: "请选择投放时段"
        }
      }
    };
  },
  computed: {
    isLook() {
      return this.$route.query.operate === "look";
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id);
    }
  },
  methods: {
    getData(id) {
      this.$axios.get(`${apis.get_ad_serving}/${id}`).then(res => {
        this.formData = res.data.data;
        for (let i = 0; i < this.formData.adv_details.length; i++) {
          this.formData.adv_details[i].date = [
            this.formData.adv_details[i].date_start,
            this.formData.adv_details[i].date_end
          ];
        }
        this.selectCabinetList = this.formData.terminal_list;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    closeSimpleDialog(data) {
      this.dialogVisible = false;
      switch (this.nowDialog) {
        case "cabinet":
          this.selectCabinetList = this.selectCabinetList.concat(data);
          this.selectCabinetList = this.selectCabinetList.filter(
            (item, index) => {
              var arrids = [];
              this.selectCabinetList.forEach((x, i) => {
                arrids.push(x.tid);
              });

              return arrids.indexOf(item.tid) === index;
            }
          );
          break;
        case "adv":
          this.formData.adv_details = this.formData.adv_details.concat(data);
          this.formData.adv_details = this.formData.adv_details.filter(
            (item, index) => {
              var arrids = [];
              this.formData.adv_details.forEach((x, i) => {
                arrids.push(x.id);
              });
              return arrids.indexOf(item.id) === index;
            }
          );
          break;
      }
    },
    // 新增货柜
    addNewCabinet() {
      this.dialogVisible = true;
      this.nowDialog = "cabinet";
      this.dialogData = {
        searchItems: [
          {
            key: "hard_number",
            label: "机器编号"
          }
        ],
        searchTableItem: [
          {
            key: "data",
            name: "机器信息"
          }
        ],
        proxyLink: "get_terminal_list",
        proxyType: "get"
      };
    },
    removeCabinet(index) {
      this.selectCabinetList.splice(index, 1);
    },
    addAdv() {
      this.dialogVisible = true;
      this.nowDialog = "adv";
      this.dialogData = {
        searchItems: [
          {
            key: "title",
            label: "广告名称"
          },
          {
            key: "adv_type",
            hidden: true,
            value: this.formData.serving_type
          }
        ],
        searchTableItem: [
          {
            key: "title",
            name: "广告名称"
          },
          {
            key: "rel_name",
            name: "创建人"
          }
        ],
        proxyLink: "advert_list",
        proxyType: "get"
      };
    },
    removeAdv(index) {
      this.formData.adv_details.splice(index, 1);
    },
    submit() {
      this.formData.terminal_ids = this.selectCabinetList.map(item => {
        console.log(item);
        return item.tid;
      });
      this.$refs.form.validate(valid => {
        if (valid && this.validateTable()) {
          this.formData.adv_details.forEach(adv => {
            adv.date_start = adv.date[0];
            adv.date_end = adv.date[1];
          });
          if (this.$route.query.id) {
            this.$axios
              .put(
                `${apis.update_serving}/${this.$route.query.id}`,
                this.formData
              )
              .then(res => {
                this.goBack();
              });
          } else {
            this.$axios
              .post(apis.terminal_ad_serving, this.formData)
              .then(res => {
                this.goBack();
              });
          }
        }
      });
    },
    changeServingType() {
      this.formData.adv_details = [];
    },
    validateTable() {
      if (this.formData.adv_details.length === 0) {
        this.$message.error("请选择广告");
        return false;
      } else {
        //广告序号是否存在
        let playIndexExits = this.formData.adv_details.filter(item => {
          return !item.index;
        });
        //广告时间是否存在
        let palyDate = this.formData.adv_details.filter(item => {
          return !item.date;
        });
        //广告重复次数是否存在
        let playNumExits = this.formData.adv_details.filter(item => {
          return !item.replay;
        });
        let playTimeExits = [];
        //广告时长是否存在
        if (this.formData.serving_type === "IMAGE") {
          playTimeExits = this.formData.adv_details.filter(item => {
            return !item.play_time;
          });
        }
        if (playIndexExits.length > 0) {
          this.$message.error("广告序号不存在");
          return false;
        }
        if (palyDate.length > 0) {
          this.$message.error("广告时间不存在");
          return false;
        }
        if (playNumExits.length > 0) {
          this.$message.error("广告重复次数不存在");
          return false;
        }
        if (playTimeExits.length > 0) {
          this.$message.error("广告时长不存在");
          return false;
        }
        let playIndex = this.formData.adv_details.map(item => {
          return item.index;
        });
        playIndex = [...new Set(playIndex)];
        if (playIndex.length !== this.formData.adv_details.length) {
          this.$message.error("广告序号重复");
          return false;
        }
      }
      return true;
    }
  }
};
</script>
<style lang="scss">
.el-date-editor.el-input.inline-date-picker,
.el-date-editor.el-input__inner.inline-date-picker {
  width: 100%;
}
</style>